import ModalCloseButton from '../../../Component/UI/ModalCloseButton';
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import api from "../../../Component/axios_Interceptor/api";
import api2 from "../../../Component/axios_Interceptor/api2";
import url, { SERVER_ADDRESS } from "../../../Component/server";
import { fontStyles } from "../../../Component/style/admin_font";
import {
  CenterView,
  CheckBox,
  Icon,
  RowView,
  RowView2,
} from "../../../Component/style/common_style";
import Layout_Admin from "../../../Component/UI/Layout_Admin";
import AdminPageHeader from "../../../Component/UI/AdminPageHeader";
import Calendar from "./Component/Calendar";
import CoinPaymentModal from "./Modal/CoinPaymentModal";
import ShippingPolicyFields, { ShippingMode } from './Component/ShippingPolicyFields';
import { isElapsedLiveHour, liveDateAtHour } from './liveScheduleTime';

import PaymentPolicyFields, { PaymentPolicy, paymentPolicyError, readPaymentPolicy, defaultPaymentDeadline } from './Component/PaymentPolicyFields';

const getFormattedSummaryDate = (dateArr: string[], time: number[]) => {
  if (time.length === 0) return { dateTimeStr: "", durationStr: "" };

  const startIdx = time[0];
  const endIdx = time[time.length - 1] + 1;


  const startHour = startIdx % 24;
  const startHourStr = startHour < 10 ? `0${startHour}:00` : `${startHour}:00`;
  const startDateStr = liveDateAtHour(dateArr, startIdx);


  const endHour = endIdx % 24;
  const endHourStr = endHour < 10 ? `0${endHour}:00` : `${endHour}:00`;
  const endDateStr = liveDateAtHour(dateArr, endIdx);

  const duration = time.length;

  return {
    dateTimeStr: `${startDateStr.replaceAll("-", ".")} ${startHourStr} ~ ${endDateStr.replaceAll("-", ".")} ${endHourStr}`,
    durationStr: `(${duration}시간)`
  };
};

const LiveMake = () => {
  const Navigate = useNavigate();

  const [livedate, setLivedate] = useState<string[]>([]);
  const [livetime, setLivetime] = useState<number[]>([]);
  const [live_limit, setLive_limit] = useState(0);
  const [detailsOpen, setDetailsOpen] = useState(false);
  useEffect(() => {
    if (!detailsOpen) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const closeOnEscape = (event: KeyboardEvent) => { if (event.key === "Escape" && !event.defaultPrevented) setDetailsOpen(false); };
    window.addEventListener("keydown", closeOnEscape);
    return () => { document.body.style.overflow = previousOverflow; window.removeEventListener("keydown", closeOnEscape); };
  }, [detailsOpen]);
  const [live_title, setLive_title] = useState("");
  const [live_img, setLive_img] = useState<string>("");
  const [picPreview, setPicPreview] = useState("");
  const [imageUploading, setImageUploading] = useState(false);
  const [imageReady, setImageReady] = useState(false);
  const [imageError, setImageError] = useState("");
  const imageRequest = useRef(0);
  const imageUpload = useRef<AbortController | null>(null);
  const previewRequest = imageRequest.current;
  useEffect(() => () => {imageRequest.current += 1; imageUpload.current?.abort();}, []);
  const [secret_yn, setSecret_yn] = useState(false);
  const handleSecret_yn = () => {
    setSecret_yn(!secret_yn);
  };

  const [unavailableTime, setUnavailableTime] = useState<number[]>([]);
  const [unavailableTimeSecond, setUnavailableTimeSecond] = useState<number[]>([]);
  const [cancel_ticket, setCancel_ticket] = useState(0);
  const [paymentPolicy, setPaymentPolicy] = useState<PaymentPolicy>(() => readPaymentPolicy());
  const [deadlineEdited, setDeadlineEdited] = useState(false);
  const [pgDeadlineEdited, setPgDeadlineEdited] = useState(false);

  const [shippingMode, setShippingMode] = useState<ShippingMode>('threshold');
  const [baseDeliveryPrice, setBaseDeliveryPrice] = useState(4000);
  const [freeShippingThreshold, setFreeShippingThreshold] = useState(50000);
  const [jejuDeliveryPrice, setJejuDeliveryPrice] = useState(7000);
  const [remoteDeliveryPrice, setRemoteDeliveryPrice] = useState(7000);
  const [visibleMonth, setVisibleMonth] = useState(() => {
    const date = new Date();
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
  });
  const [scheduleCounts, setScheduleCounts] = useState<Record<string, number>>({});
  const [countLoading, setCountLoading] = useState(false);
  const [countError, setCountError] = useState(false);

  useEffect(() => {
    let active = true;
    const load = async () => {
      setCountLoading(true);
      setCountError(false);
      setScheduleCounts({});
      try {
        let counts: Record<string, number> | null = null;
        try {
          const response = await api.get(url.Communication_url.live_schedule_counts, { params: { month: visibleMonth } });
          const data = response.data;
          if (data && typeof data === 'object' && !Array.isArray(data)
            && Object.values(data).every(count => Number.isInteger(count) && (count as number) >= 0)) {
            counts = data;
          }
        } catch (error: any) {
          if (error?.response?.status !== 404) throw error;
        }
        // Older deployed servers can return a 200 HTML page for an unknown API route.
        if (counts === null) {
          counts = {};
          for (let page = 1; ; page += 1) {
            const response = await api.get(url.Communication_url.get_live_list, {
              params: { currentPage: page, perPage: 100, sort: 'DESC' },
            });
            const lives = Array.isArray(response.data?.liveList) ? response.data.liveList : [];
            for (const live of lives) {
              const date = String(live.live_start || '').slice(0, 10);
              if (date.startsWith(`${visibleMonth}-`) && live.live_status !== '취소') {
                counts[date] = (counts[date] || 0) + 1;
              }
            }
            if (!lives.length || page * 100 >= Number(response.data?.total || 0)
              || lives.some((live: any) => String(live.live_start || '').slice(0, 7) < visibleMonth)) break;
          }
        }
        if (active) setScheduleCounts(counts);
      } catch (error) {
        if (active) { setCountError(true); setScheduleCounts({}); }
      } finally {
        if (active) setCountLoading(false);
      }
    };
    void load();
    return () => { active = false; };
  }, [visibleMonth]);

  const [focusDateIdx, setFocusDateIdx] = useState(0);
  const [now, setNow] = useState(() => new Date());

  const timeList = new Array(24).fill("");
  const countList = [...Array.from({ length: 20 }, (_, index) => 50 * (index + 1)), 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000];

  const unavailable_time_check = async (dateStr: string, setter: React.Dispatch<React.SetStateAction<number[]>>) => {
    try {
      const res = await api.get(url.Communication_url.unavailable_time, {
        params: { select_date: dateStr, userid: "seller1" },
      });
      const data = res.data;
      const result = data.flatMap((item: any) => {
        if (item.end === `${dateStr} 00:00:00`) {
          return [];
        }
        const startHour = new Date(item.start).getHours();
        const endHour = new Date(item.end).getHours();
        return getTimeArr(startHour, endHour);
      });
      setter(result);
    } catch (error) {
      console.error("실패:", error);
    }
  };

  const getTimeArr = (start: number, end: number) => {
    const range = [];
    const actualEnd = end === 0 ? 23 : end - 1;
    for (let i = start; i <= actualEnd; i++) {
      range.push(i);
    }
    return range;
  };

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 60_000);
    return () => window.clearInterval(timer);
  }, []);

  useEffect(() => {
    setLivetime(current => {
      const available = current.filter(time => !isElapsedLiveHour(livedate, time, now));
      return available.length === current.length ? current : available;
    });
  }, [livedate, now]);

  useEffect(() => {
    if (livedate.length > 1 && livetime.length > 0) {
      setFocusDateIdx(1);
    } else {
      setFocusDateIdx(0);
    }
    if (livedate.length > 0) {
      unavailable_time_check(livedate[0], setUnavailableTime);
      if (livedate.length > 1) {
        unavailable_time_check(livedate[1], setUnavailableTimeSecond);
      } else {
        setUnavailableTimeSecond([]);
      }
    }
  }, [livedate]);

  const setting_livetime = (time: number) => {
    if (isUnableTime(time) && !livetime.includes(time)) {
      return;
    }
    let copyArr = [...livetime];
    // 배열 삭제
    if (livetime[0] === time) {
      const delArr = copyArr.filter((num) => num !== time);
      setLivetime(delArr);
      return;
    }
    if (livetime.includes(time)) {
      const delArr = copyArr.filter((num) => num < time);
      setLivetime(delArr);
      return;
    }
    // 배열 등록
    if (livetime.length > 0 && time > livetime[livetime.length - 1]) {
      const lastNum = livetime[livetime.length - 1];
      for (let i = lastNum + 1; i <= time; i++) {
        copyArr.push(i);
      }
      copyArr.sort((a, b) => a - b);
      setLivetime(copyArr);
      return;
    }
    if (livetime.length > 0 && livetime[0] - 1 !== time) {
      for (let i = time; i < livetime[0]; i++) {
        copyArr.push(i);
      }
      copyArr.sort((a, b) => a - b);
      setLivetime(copyArr);
      return;
    }
    copyArr = [...livetime, time];
    copyArr.sort((a, b) => a - b);
    setLivetime(copyArr);
  };
  const setting_title = (e: React.ChangeEvent<HTMLInputElement>) =>
    setLive_title(e.target.value);

  const picPreviewRef = useRef<HTMLInputElement | null>(null);
  const insert_pic = () => {
    if (picPreviewRef && picPreviewRef.current) {
      picPreviewRef.current.click();
    }
  };
  const allowedExtensions = [".png", ".jpg", ".jpeg"];
  const renderPic = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!allowedExtensions.some(ext => file.name.toLowerCase().endsWith(ext)) || !/^image\/(jpeg|png)$/.test(file.type)) {
      setImageError("PNG 또는 JPG 이미지를 선택해주세요."); return;
    }
    if (!file.size || file.size > 10 * 1024 * 1024) {
      setImageError("이미지는 0바이트보다 크고 10MB 이하여야 합니다."); return;
    }
    void setting_pic(file);
  };
  const setting_pic = async (file: File) => {
    const request = ++imageRequest.current;
    imageUpload.current?.abort();
    const controller = new AbortController();
    imageUpload.current = controller;
    setImageUploading(true); setImageReady(false); setImageError("");
    setLive_img(""); setPicPreview("");
    try {
      const form = new FormData();
      form.append("file", file);
      const res = await api.post(url.Communication_url.upload_live_img, form, {
        signal: controller.signal, headers: { "Content-Type": "multipart/form-data" },
      });
      if (request !== imageRequest.current || controller.signal.aborted) return;
      if (typeof res.data?.file_path !== "string" || !res.data.file_path.trim()) throw new Error("이미지 저장 결과를 확인하지 못했습니다.");
      setLive_img(res.data.file_path); setPicPreview(res.data.file_path);
    } catch (error: any) {
      if (request !== imageRequest.current || controller.signal.aborted) return;
      const message = error?.response?.data?.message;
      setImageError(typeof message === "string" ? message : "이미지를 업로드하지 못했습니다. 연결 상태를 확인하고 다시 첨부해주세요.");
    } finally {
      if (request === imageRequest.current) {imageUpload.current = null; setImageUploading(false);}
    }
  };

  // 이모지 체크
  // const emojiRegex = /[\p{Emoji_Presentation}\u200d]+/gu;
  const emojiRegex =
    /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2600-\u26FF]|\uFE0F)/g;

  // 라이브 예약 체크
  const create_live_API = async () => {
    if (imageUpload.current || !imageReady) return;
    if (livetime.length === 0 || live_title === "" || live_img === "") {
      alert("방송 시간, 제목, 대기 이미지를 모두 입력해주세요.");
      return;
    }
    if (emojiRegex.test(live_title)) {
      alert("제목에 이모지는 사용할 수 없습니다.");
      return;
    }
    if (shippingMode !== 'free' && (baseDeliveryPrice <= 0 || (shippingMode === 'threshold' && freeShippingThreshold <= 0) || jejuDeliveryPrice <= 0 || remoteDeliveryPrice <= 0)) {
      alert('무료배송 기준과 지역별 배송비를 모두 입력해주세요.');
      return;
    }

    const paymentError = paymentPolicyError(paymentPolicy);
    if (paymentError) { alert(paymentError); return; }
    setDetailsOpen(false);
    handleModal();
  };

  // 결제 모달
  const [visible, setVisible] = useState(false);
  const handleModal = () => {
    setVisible(!visible);
  };

  const make_date = (
    dateArr: string[],
    time: number[],
    type: "start" | "finish"
  ) => {
    const targetIdx = type === "start" ? time[0] : time[time.length - 1] + 1;
    const targetHour = targetIdx % 24;
    const baseDateStr = liveDateAtHour(dateArr, targetIdx);
    return new Date(`${baseDateStr}T${String(targetHour).padStart(2, "0")}:00:00+09:00`).toISOString();
  };

  useEffect(() => {
    if (!livedate.length || !livetime.length) return;
    const deadline = defaultPaymentDeadline(make_date(livedate, livetime, "finish"));
    setPaymentPolicy(current => ({...current,...(!deadlineEdited ? {deposit_deadline:deadline} : {}),...(!pgDeadlineEdited ? {pg_deadline:deadline} : {})}));
  }, [livedate, livetime, deadlineEdited, pgDeadlineEdited]);

  // 못쓰는 시간 체크
  const isUnableTime = (idx: number) => {
    const isSecondDay = idx >= 24;
    const actualHour = idx % 24;
    const targetUnavailable = isSecondDay ? unavailableTimeSecond : unavailableTime;

    if (isElapsedLiveHour(livedate, idx, now)) {
      return true;
    }
    if (!targetUnavailable || targetUnavailable.length === 0) {
      return false;
    }
    return targetUnavailable.includes(actualHour);
  };

  return (
    <Layout_Admin menuname={"라이브 목록"}>
      <LiveMakePageHeader title="라이브 만들기" description="방송 일정과 기본 정보를 설정합니다." onBack={() => Navigate("/admin/livelist")} />

      <InsertArea>
        <ScheduleArea>
          <CalendarCard>
            <CalendarCardHeader>
              <div><CardEyebrow>STEP 01</CardEyebrow><h2>방송 날짜</h2></div>
              <CalendarLegend aria-label="날짜 상태 안내"><span><LegendDot />예약 가능</span><span><LegendDot $unavailable />예약 불가</span></CalendarLegend>
            </CalendarCardHeader>
            <CalendarSlot>
              <Calendar
                livedate={livedate}
                setLivedate={setLivedate}
                setLivetime={setLivetime}
                livetime={livetime}
                setFocusDateIdx={setFocusDateIdx}
                scheduleCounts={scheduleCounts}
                onMonthChange={setVisibleMonth}
              />
            </CalendarSlot>
            {countLoading && <CountMessage role="status">방송 건수를 불러오는 중입니다.</CountMessage>}
            {countError && <CountMessage role="status">방송 건수를 불러오지 못했습니다.</CountMessage>}
          </CalendarCard>
          <BookingPanel>
            <PanelHeader>
              <CardEyebrow>STEP 02</CardEyebrow>
              <h2>예약 설정</h2>
              <SelectedDate>{livedate[focusDateIdx] || '날짜를 선택해 주세요'}</SelectedDate>
            </PanelHeader>
            <PanelSection>
              <SectionTitle>시간 설정 <span>{livetime.length > 0 ? `${livetime.length}시간 선택` : '시간 선택'}</span></SectionTitle>
              <ScrollBox aria-label="방송 시간 선택">
                {timeList.map((_, idx) => {
                  const absoluteIdx = idx + focusDateIdx * 24;
                  const hour = idx < 10 ? `0${idx}` : idx;
                  if (livedate.length > 0 && isElapsedLiveHour(livedate, absoluteIdx, now)) return null;
                  return (
                    <ClickBox type="button" key={idx}
                      disabled={!livedate.length || isUnableTime(absoluteIdx)}
                      aria-pressed={livetime.includes(absoluteIdx)}
                      className={livetime.includes(absoluteIdx) ? 'this' : isUnableTime(absoluteIdx) ? 'unable' : ''}
                      onClick={() => setting_livetime(absoluteIdx)}>
                      {`${hour}:00`}
                    </ClickBox>
                  );
                })}
              </ScrollBox>
            </PanelSection>
            <PanelSection>
              <SectionTitle>수용 인원 <span>{live_limit ? `${live_limit.toLocaleString()}명 선택` : '인원 선택'}</span></SectionTitle>
              <ScrollBox aria-label="수용 인원 선택">
                {countList.map((countnum) => (
                  <ClickBox type="button" key={countnum}
                    disabled={!livedate.length}
                    aria-pressed={live_limit === countnum}
                    className={live_limit === countnum ? 'this' : ''}
                    onClick={() => { setLive_limit(countnum); if (livetime.length > 0) setDetailsOpen(true); }}>
                    {`${countnum.toLocaleString()}명`}
                  </ClickBox>
                ))}
              </ScrollBox>
            </PanelSection>
            {livetime.length > 0 && live_limit !== 0 && !detailsOpen && <ScheduleSelection>
              <span>{getFormattedSummaryDate(livedate, livetime).dateTimeStr} · {live_limit.toLocaleString()}명</span>
              <button type="button" onClick={() => setDetailsOpen(true)}>상세 설정 열기</button>
            </ScheduleSelection>}
          </BookingPanel>
        </ScheduleArea>
        {livetime.length > 0 && live_limit !== 0 && detailsOpen && (
          <DetailsBackdrop data-admin-modal-overlay="" onClick={() => setDetailsOpen(false)}>
            <DetailsDialog data-admin-modal="" role="dialog" aria-modal="true" aria-labelledby="live-details-title" onClick={event => event.stopPropagation()}>
              <DetailsHeader data-admin-modal-header="">
                <DetailsHeading id="live-details-title">라이브 상세 설정</DetailsHeading>
                <DetailsClose tone="admin" type="button" aria-label="상세 설정 닫기" onClick={() => setDetailsOpen(false)} />
              </DetailsHeader>
              <DetailsArea data-admin-modal-body="">
                <DetailsColumns>
                  <DetailsColumn>
                    <DetailsSectionTitle>방송 정보</DetailsSectionTitle>
              <div>라이브 제목 <RequiredMark aria-hidden="true">*</RequiredMark></div>
              <InputBox
                aria-label="라이브 제목" aria-required="true"
                value={live_title}
                onChange={setting_title}
                placeholder="라이브 제목을 입력해주세요."
              />

              <div>대기 이미지 <RequiredMark aria-hidden="true">*</RequiredMark></div>
              <PicBox onClick={insert_pic}>
                {picPreview ? (
                  <Icon key={picPreview} src={SERVER_ADDRESS + "openfile/" + picPreview} alt="업로드한 라이브 이미지" onLoad={() => {if (previewRequest === imageRequest.current) setImageReady(true);}} onError={() => {if (previewRequest === imageRequest.current) {setImageReady(false); setImageError("저장된 이미지를 불러오지 못했습니다. 다시 첨부해주세요.");}}} />
                ) : (
                  <div>+</div>
                )}
              </PicBox>
              {imageUploading && <p role="status">이미지를 업로드하는 중입니다.</p>}
              {!imageUploading && picPreview && !imageReady && !imageError && <p role="status">저장된 이미지를 확인하는 중입니다.</p>}
              {imageError && <p role="alert" style={{color: "var(--admin-theme-danger, #a3253c)"}}>{imageError}</p>}

              <div style={{ marginTop: 20 }}>주문 취소 쿠폰</div>
              <CouponContainer>
                <InputBox
                  value={cancel_ticket}
                  readOnly
                  style={{ flex: 1, textAlign: "center", margin: 0 }}
                />
                <CouponBtn onClick={() => setCancel_ticket(prev => Math.max(0, prev - 1))}>-</CouponBtn>
                <CouponBtn onClick={() => setCancel_ticket(prev => prev + 1)}>+</CouponBtn>
              </CouponContainer>



              <PaymentPolicyFields manageAccounts value={paymentPolicy} liveFinish={livedate.length && livetime.length ? make_date(livedate,livetime,"finish") : null} onChange={next => {
                if (next.deposit_deadline !== paymentPolicy.deposit_deadline) setDeadlineEdited(true);
                if (next.pg_deadline !== paymentPolicy.pg_deadline) setPgDeadlineEdited(true);
                setPaymentPolicy(next);
              }} />

                  </DetailsColumn>
                  <DetailsColumn>
                    <DetailsSectionTitle>배송 및 공개</DetailsSectionTitle>
              <ShippingPolicyFields mode={shippingMode} baseDeliveryPrice={baseDeliveryPrice}
                freeShippingThreshold={freeShippingThreshold} jejuDeliveryPrice={jejuDeliveryPrice} remoteDeliveryPrice={remoteDeliveryPrice} onModeChange={setShippingMode}
                onBaseDeliveryPriceChange={setBaseDeliveryPrice}
                onFreeShippingThresholdChange={setFreeShippingThreshold}
                onJejuDeliveryPriceChange={setJejuDeliveryPrice} onRemoteDeliveryPriceChange={setRemoteDeliveryPrice} />

              <RowView2 style={{ marginTop: 40 }}>
                <CheckBox
                  type={"checkbox"}
                  checked={secret_yn}
                  readOnly
                  onClick={handleSecret_yn}
                />
                <div style={{ marginLeft: 5 }}>
                  <div>팔로우한 회원에게만 방송 보이기</div>
                  <div style={{ fontSize: 14, color: "var(--admin-theme-danger, red)" }}>
                    *설정시 수정할 수 없습니다.
                  </div>
                </div>
              </RowView2>

                  </DetailsColumn>
                </DetailsColumns>
              </DetailsArea>
              <DetailsFooter data-admin-modal-footer="">
              <SummaryBox>
                <RowView>
                  <div className="label">예약일시</div>
                  <div className="value">
                    {(() => {
                      const { dateTimeStr, durationStr } = getFormattedSummaryDate(livedate, livetime);
                      return (
                        <>
                          {dateTimeStr}
                          <span
                            style={{
                              color: "var(--admin-muted)",
                              marginLeft: "6px",
                              fontFamily: "var(--font-family-base)",
                              fontWeight: "normal",
                            }}
                          >
                            {durationStr}
                          </span>
                        </>
                      );
                    })()}
                  </div>
                </RowView>
                <RowView style={{ marginTop: 10 }}>
                  <div className="label">시청자수</div>
                  <div className="value">{live_limit}명</div>
                </RowView>
              </SummaryBox>

              <FooterAction>
                <Btn type="button" disabled={imageUploading || !imageReady}
                  className={
                    livetime.some((item) => isUnableTime(item)) ||
                      livetime.length === 0 ||
                      live_title === "" ||
                      live_img === ""
                      ? ""
                      : "main"
                  }
                  onClick={create_live_API}
                >
                  라이브 만들기
                </Btn>
              </FooterAction>
              </DetailsFooter>
            </DetailsDialog>
          </DetailsBackdrop>
        )}
      </InsertArea>
      <input
        style={{ display: "none" }}
        ref={picPreviewRef}
        type="file"
        accept="image/png,image/jpeg"
        aria-label="라이브 이미지 첨부"
        onChange={renderPic}
      />
      {livetime.length !== 0 && live_title !== "" && (
        <CoinPaymentModal
          paymentPolicy={paymentPolicy}
          visible={visible}
          handleModal={handleModal}
          livedate={livedate}
          live_start={new Date(make_date(livedate, livetime, "start"))}
          live_finish={new Date(make_date(livedate, livetime, "finish"))}
          live_title={live_title}
          live_img={live_img}
          live_limit={live_limit}
          secret_yn={secret_yn}
          cancel_ticket={cancel_ticket}
          shipping_mode={shippingMode}
          base_delivery_price={shippingMode === 'free' ? 0 : baseDeliveryPrice}
          free_shipping_threshold={shippingMode === 'threshold' ? freeShippingThreshold : null}
          jeju_delivery_price={shippingMode === 'free' ? 0 : jejuDeliveryPrice}
          remote_delivery_price={shippingMode === 'free' ? 0 : remoteDeliveryPrice}
        />
      )}
    </Layout_Admin>
  );
};

export default LiveMake;

const InsertArea = styled.div`
  display: flex; flex-direction: column; gap: 24px; min-width: 0;
`;
const ScheduleArea = styled.div`
  display: grid; grid-template-columns: minmax(0, 1280px) minmax(340px, 420px);
  justify-content: start; align-items: stretch; gap: 20px;
  width: 100%; margin: 0 0 24px; min-width: 0;
  @media (max-width: 1350px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
const LiveMakePageHeader = styled(AdminPageHeader)`
  && button[aria-label="이전 화면으로"] {
    border-color: var(--color-brand); background: var(--color-brand-subtle); color: var(--color-text-link);
    font-size: var(--text-display); line-height: 1;
  }
  && button[aria-label="이전 화면으로"]:hover {
    border-color: var(--color-brand-hover); background: var(--color-bg-subtle);
  }
`;
const CalendarCard = styled.section`
  box-sizing: border-box; min-width: 0; padding: 22px;
  border: 1px solid var(--admin-theme-border, #e9e4f1); border-radius: 18px; background: var(--admin-theme-surface, #fff);
  box-shadow: 0 12px 32px rgba(43, 28, 75, .045);
  @media (max-width: 600px) { padding: 12px; border-radius: 12px; }
`;
const CalendarCardHeader = styled.div`
  display: flex; align-items: end; justify-content: space-between; gap: 10px;
  margin-bottom: 14px;
  h2 { margin: 4px 0 0; color: var(--admin-theme-text, #2d2737); font-size: 22px; font-weight: 700; }
  @media (max-width: 560px) { h2 { font-size: 19px; } }
`;
const CardEyebrow = styled.div`
  color: var(--admin-theme-link, #7447da); font-size: 11px; font-weight: 800; letter-spacing: .08em;
`;
const CalendarLegend = styled.span`
  display: flex; flex-wrap: wrap; align-items: center; gap: var(--space-3); color: var(--color-text-secondary);
  font-size: var(--text-caption);
  > span { display: inline-flex; align-items: center; gap: var(--space-1); white-space: nowrap; }
`;
const LegendDot = styled.i<{ $unavailable?: boolean }>`
  width: var(--space-2); height: var(--space-2); border-radius: var(--radius-pill);
  background: ${p => p.$unavailable ? 'var(--color-text-disabled)' : 'var(--color-success)'};
`;
const CalendarSlot = styled.div`
  min-width: 0; width: 100%;
`;
const CountMessage = styled.p`
  margin: 9px 0 0; color: var(--admin-theme-muted, #8c8499); font-size: 12px;
`;
const BookingPanel = styled.aside`
  box-sizing: border-box; display: flex; flex-direction: column; gap: 19px;
  min-width: 0; padding: 22px; border: 1px solid var(--admin-theme-border, #e9e4f1); border-radius: 18px;
  background: var(--admin-theme-surface, #fff); box-shadow: 0 12px 32px rgba(43, 28, 75, .045);
  @media (max-width: 1350px) { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); align-items: start; }
  @media (max-width: 600px) { display: flex; padding: 16px; border-radius: 12px; }
`;
const PanelHeader = styled.div`
  padding-bottom: 14px; border-bottom: 1px solid var(--admin-theme-border, #eee9f4);
  h2 { margin: 4px 0 10px; color: var(--admin-theme-text, #2d2737); font-size: 22px; font-weight: 700; }
  @media (max-width: 1350px) { grid-column: 1 / -1; }
`;
const SelectedDate = styled.div`
  padding: 10px 12px; border-radius: 9px; background: var(--admin-theme-accent-soft, #f6f2ff);
  color: var(--admin-theme-link, #5d38bb); font-size: 13px; font-weight: 700;
`;
const PanelSection = styled.div`min-width: 0;`;
const SectionTitle = styled.div`
  display: flex; justify-content: space-between; gap: 8px; align-items: center;
  margin-bottom: 9px; color: var(--admin-theme-text, #332b3c); font-size: 14px; font-weight: 700;
  span { color: var(--admin-theme-muted, #8d849a); font-size: 12px; font-weight: 500; }
`;
const ScrollBox = styled.div`
  box-sizing: border-box; display: grid; grid-template-columns: repeat(3, minmax(0, 1fr));
  align-content: start; gap: 7px; height: 208px; overflow-y: auto; padding: 2px 4px 2px 2px;
  scrollbar-width: thin; scrollbar-color: var(--admin-theme-muted, #d9c9f7) transparent;
  @media (max-width: 1350px) { grid-template-columns: repeat(4, minmax(0, 1fr)); }
`;
const ClickBox = styled.button`
  min-width: 0; height: 37px; padding: 0 4px; border: 1px solid var(--admin-theme-border, #e7e1ef);
  border-radius: 8px; background: var(--admin-theme-surface, #fff); color: var(--admin-theme-text, #544c60);
  font: inherit; font-size: 12px; font-weight: 600; cursor: pointer;
  &:hover:not(:disabled) { background: var(--admin-theme-accent-soft, #f6f2ff); border-color: var(--admin-theme-border, #bda6f4); }
  &:focus-visible { outline: 3px solid var(--admin-theme-focus, #a993ef); outline-offset: 2px; }
  &.this { background: #693bd5; border-color: #693bd5; color: #fff; }
  &:disabled { background: var(--admin-theme-raised, #f8f7fa); color: var(--admin-theme-muted, #bbb4c4); cursor: default; }
  &.unable { text-decoration: line-through; }
`;
const ScheduleSelection = styled.div`
  display: flex; flex-direction: column; gap: 10px; padding-top: 14px;
  border-top: 1px solid var(--admin-theme-border, #eee9f4); color: var(--admin-theme-text, #40364e); font-size: 13px; font-weight: 700;
  button { min-height: 38px; border: 0; border-radius: 8px; background: #5d35d3; color: #fff; font: inherit; cursor: pointer; }
  @media (max-width: 1350px) { grid-column: 1 / -1; }
`;
const RequiredMark = styled.span`color: var(--admin-theme-danger, #d84059); font-weight: 800;`;
const DetailsBackdrop = styled.div`
  position: fixed; inset: 0; z-index: 1200; display: grid; place-items: center; padding: 18px;
  background: rgba(18, 12, 30, .64);
`;
const DetailsDialog = styled.div`
  box-sizing: border-box; display: flex; flex-direction: column;
  width: min(100%, 1180px); max-height: calc(100dvh - 36px); overflow: hidden;
  border-radius: 16px; background: var(--admin-theme-surface, #fff); box-shadow: 0 24px 70px rgba(0, 0, 0, .25);
`;
const DetailsHeader = styled.div`
  flex: none; display: flex; align-items: center; justify-content: space-between;
  min-height: 62px; padding: 0 24px; border-bottom: 1px solid var(--admin-theme-border, #e6e2ed); background: var(--admin-theme-surface, #fff);
`;
const DetailsClose = styled(ModalCloseButton)``;
const DetailsArea = styled.section`
  box-sizing: border-box; flex: 1; min-height: 0; width: 100%; min-width: 0;
  padding: 22px 24px; overflow-y: auto; background: var(--admin-theme-surface, #fff);
  @media (max-width: 600px) { padding: 18px; }
`;
const DetailsColumns = styled.div`
  display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 28px;
  @media (max-width: 900px) { grid-template-columns: 1fr; gap: 24px; }
`;
const DetailsColumn = styled.div`
  min-width: 0;
  & + & { padding-left: 28px; border-left: 1px solid var(--admin-theme-border, #ebe7f0); }
  @media (max-width: 900px) {
    & + & { padding: 24px 0 0; border-left: 0; border-top: 1px solid var(--admin-theme-border, #ebe7f0); }
  }
`;
const DetailsSectionTitle = styled.h3`
  margin: 0 0 18px; padding-bottom: 10px; border-bottom: 1px solid var(--admin-theme-border, #ebe7f0);
  color: var(--admin-theme-text, #392d56); font-size: 16px; font-weight: 700;
`;
const DetailsFooter = styled.div`
  flex: none; display: grid; grid-template-columns: minmax(0, 1fr) 200px;
  align-items: center; gap: 20px; padding: 14px 24px;
  border-top: 1px solid var(--admin-theme-border, #e6e2ed); background: var(--admin-theme-surface, #fff);
  @media (max-width: 600px) { grid-template-columns: 1fr; gap: 10px; padding: 14px 18px; }
`;
const FooterAction = styled.div`
  button { width: 100%; min-height: 48px; margin: 0; }
`;
const DetailsHeading = styled.h2`
  margin: 0;
  color: var(--admin-theme-text, #302a38);
  font-size: 20px;
  ${fontStyles.Bold}
`;
const InputBox = styled.input`
  box-sizing: border-box;
  width: 100%;
  padding: 0.8rem;
  margin: 1rem 0rem;
  font-size: 16px;
  border: 1px solid var(--admin-theme-border, #f0f0f0);
  outline: 0;
  border-radius: 8px;
  &:hover,
  &:focus {
    border: 1px solid var(--admin-theme-focus, #454545);
  }
`;
const Btn = styled.button`
  border: 0;
  &:disabled {cursor: not-allowed;}
  padding: 0.8rem 1.5rem;
  margin-bottom: 0;
  ${fontStyles.medium}
  font-size: 16px;
  border-radius: 8px;
  background: var(--admin-theme-raised, #eeeeee);
  color: var(--admin-theme-muted, #a5a5a5);
  &.main {
    color: white;
    background: linear-gradient(135deg, var(--admin-accent), var(--admin-accent-deep));
    cursor: pointer;
  }
`;
const PicBox = styled(CenterView)`
  position: relative;
  width: 6rem;
  height: 6rem;
  margin: 1rem 0rem;
  color: var(--admin-theme-muted, #c6c6c6);
  font-size: 24px;
  border: 1px solid var(--admin-theme-border, #f0f0f0);
  border-radius: 8px;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
  }
`;

const CouponContainer = styled(RowView2)`
  margin-top: 1rem;
  margin-bottom: 2rem;
  width: 100%;
  gap: 10px;
`;

const CouponBtn = styled.div`
  width: 46px;
  height: 46px;
  border: 1px solid var(--admin-theme-border, #f0f0f0);
  background-color: var(--admin-theme-surface, #fff);
  border-radius: 8px;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  &:hover {
    background-color: var(--admin-theme-raised, #f5f5f5);
  }
`;

const SummaryBox = styled.div`
  margin: 0;
  > div { display: grid; grid-template-columns: 88px minmax(0, 1fr); align-items: start; gap: 12px; }
  div.label {
    white-space: nowrap;
    font-size: 15px;
    color: var(--admin-muted);
    ${fontStyles.medium}
  }
  div.value {
    min-width: 0;
    overflow-wrap: anywhere;
    text-align: left;
    line-height: 1.5;
    font-size: 15px;
    color: var(--admin-theme-text, #333);
    ${fontStyles.medium}
  }
  @media (max-width: 600px) {
    > div { grid-template-columns: 1fr; gap: 4px; }
    div.value { text-align: left; }
  }
`;

const TabRow = styled(RowView2)`
  margin-top: 1rem;
  margin-bottom: 1rem;
  border-bottom: 2px solid var(--admin-theme-border, #f0f0f0);
  width: 10.5rem;
  @media ${({ theme }) => theme.mobile} {
    width: 100%;
  }
`;

const TabBtn = styled.div`
  flex: 1;
  text-align: center;
  padding: 0.5rem 0;
  cursor: pointer;
  color: var(--admin-muted);
  font-size: 14px;
  ${fontStyles.medium}
  &.active {
    color: var(--admin-theme-danger, #ea2922);
    border-bottom: 2px solid #ea2922;
    margin-bottom: -2px;
    ${fontStyles.Bold}
  }
`;
